<mat-card>
  <mat-card-title>
    Materials summary&nbsp;<button mat-icon-button (click)="exportCsv()"><mat-icon>cloud_download</mat-icon></button>
  </mat-card-title>
  <div class="example-container mat-elevation-z8">
    <mat-card>
        <mat-form-field>
            <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
          </mat-form-field>
          <span>Filtered {{ filteredTotal | currency:'EUR' }}</span>
    </mat-card>
    

    <mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="orderNr">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Order</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <a [routerLink]="['/order/view',row.orderId]">{{ row.orderNr }}</a>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="project">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Project</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.item.budget.project?.projectNr }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="author">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Author</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <div>{{ row.author }}</div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="vendor">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Vendor</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <div> {{ row.vendor }} </div>
        </mat-cell>
      </ng-container>


      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Date</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.date._seconds*1000 | date }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="unit">
        <mat-header-cell *matHeaderCellDef i18n>Unit</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.item.unit }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="quantity">
        <mat-header-cell *matHeaderCellDef i18n>Quantity</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.item.quantity }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="costEach">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Price</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.item.costEach | currency:'EUR'}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="total">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Total</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.total | currency:'EUR' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="description">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n>Description</mat-header-cell>
        <mat-cell *matCellDef="let row"> {{ row.item.description | ellipsis:100 }} </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;">
      </mat-row>
    </mat-table>

    <mat-paginator [length]="dataSource.resultsLength" [pageSizeOptions]="[25, 50, 100, 1000]"></mat-paginator>

    <mat-card>Material total:&nbsp;{{ materialTotal | currency:'EUR' }} - Filtered {{ filteredTotal | currency:'EUR' }}</mat-card>
  </div>

<!-- 
  <table *ngIf="budget$ | async as budget" class="table table-borderd">
    <tr>
      <td></td>
      <td>Total</td>
    </tr>
    <tr>
      <td>Budget</td>
      <td>{{ budget.costSummary?.goodsValue | currency:'EUR' }}</td>
    </tr>
    <ng-container *ngIf="materialTotalCost">
    <tr>
      <td>Final</td>
      <td>{{ materialTotalCost | currency:'EUR' }}</td>
    </tr>
    <tr class="difference">
      <td>Difference</td>
      <td [class.make-red]="budget.costSummary?.goodsValue > materialTotalCost">{{ budget.costSummary?.goodsValue - materialTotalCost | currency:'EUR' }}</td>
    </tr>
  </ng-container>
  </table> -->

</mat-card>



// WEBPACK FOOTER //
// ./src/app/balances/components/materials-balance-table/materials-balance-table.component.html